/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AbortGroupRecordingResponse} from "../model/abort-group-recording-response";
import {AbortRecordingRequest} from "../model/abort-recording-request";
import {ActiveTrainingSessionResponse} from "../model/active-training-session-response";
import {AddMarkerToActiveRecordingRequest} from "../model/add-marker-to-active-recording-request";
import {AddOrRemoveParticipantRequest} from "../model/add-or-remove-participant-request";
import {AddPhoneMarkerToActiveRecording} from "../model/add-phone-marker-to-active-recording";
import {AddSelectedPlayerRequest} from "../model/add-selected-player-request";
import {BroadcastToRequest} from "../model/broadcast-to-request";
import {CanStopRecordingErrorCode} from "../model/can-stop-recording-error-code";
import {ChangeCameraLayoutPresetRequest} from "../model/change-camera-layout-preset-request";
import {ChangeRoomRequest} from "../model/change-room-request";
import {ChangeRoomResponse} from "../model/change-room-response";
import {ChangeTrainingSessionStateRequest} from "../model/change-training-session-state-request";
import {ContinueTrainingSessionRequest} from "../model/continue-training-session-request";
import {ContinueTrainingSessionResponse} from "../model/continue-training-session-response";
import {CreateProTrainingSessionRequest} from "../model/create-pro-training-session-request";
import {ListData} from "../model/list-data";
import {MarkerModifiedResponse} from "../model/marker-modified-response";
import {Markerset} from "../model/markerset";
import {ParticipantType} from "../model/participant-type";
import {PlayAudioMediaRequest} from "../model/play-audio-media-request";
import {PlayMediaOnMediaScreenRequest} from "../model/play-media-on-media-screen-request";
import {PrepareScheduledTrainingSessionForRecordingResponse} from "../model/prepare-scheduled-training-session-for-recording-response";
import {RecorderMapping} from "../model/recorder-mapping";
import {ReleaseTrainingSessionStateRequest} from "../model/release-training-session-state-request";
import {RemoveSelectedPlayerRequest} from "../model/remove-selected-player-request";
import {ScenarioRecording} from "../model/scenario-recording";
import {SelectAudioMediaRequest} from "../model/select-audio-media-request";
import {SetAudioMediaLoopingRequest} from "../model/set-audio-media-looping-request";
import {SetGroupVolumeChannelRequest} from "../model/set-group-volume-channel-request";
import {SetRecorderVolumeChannelRequest} from "../model/set-recorder-volume-channel-request";
import {SetScenarioRecordingMessageRequest} from "../model/set-scenario-recording-message-request";
import {SetVolumeChannelRequest} from "../model/set-volume-channel-request";
import {SimUser} from "../model/sim-user";
import {StartGroupRecordingReponse} from "../model/start-group-recording-reponse";
import {StartGroupRecordingRequest} from "../model/start-group-recording-request";
import {StopAudioMediaRequest} from "../model/stop-audio-media-request";
import {StopBroadcastingToRequest} from "../model/stop-broadcasting-to-request";
import {StopMediaOnMediaScreenRequest} from "../model/stop-media-on-media-screen-request";
import {StopMultiRecordingRequest} from "../model/stop-multi-recording-request";
import {StopRecordingResponse} from "../model/stop-recording-response";
import {SuccessResponse} from "../model/success-response";
import {TeamTrainingSession} from "../model/team-training-session";
import {ToggleGroupMuteChannelRequest} from "../model/toggle-group-mute-channel-request";
import {ToggleGroupSoloChannelRequest} from "../model/toggle-group-solo-channel-request";
import {ToggleMuteChannelRequest} from "../model/toggle-mute-channel-request";
import {ToggleSoloChannelRequest} from "../model/toggle-solo-channel-request";
import {ToggleVogVopVttOutputChannelRequest} from "../model/toggle-vog-vop-vtt-output-channel-request";
import {ToggleWebRecorderIsVignetteShowingRequest} from "../model/toggle-web-recorder-is-vignette-showing-request";
import {TrainingRoom} from "../model/training-room";
import {UpdateCameraViewModeRequest} from "../model/update-camera-view-mode-request";
import {UpdateMarkerTextRequest} from "../model/update-marker-text-request";
import {UpdateRecordingMetaDataRequest} from "../model/update-recording-meta-data-request";
import {UpdateShowAbsoluteTimeRequest} from "../model/update-show-absolute-time-request";
import {UpdateVolumeOfCurrentMediaRequest} from "../model/update-volume-of-current-media-request";
import {VOGSet} from "../model/vog-set";
import {VTPSet} from "../model/vtp-set";

@Injectable({
    providedIn: "root",
})
export class SimRecorderService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public abortRecording(request: AbortRecordingRequest) {
        return super.post<AbortGroupRecordingResponse>(`/api/Recorder/AbortRecording`, request);
    }

    public addMarkerToActiveRecording(request: AddMarkerToActiveRecordingRequest) {
        return super.post<MarkerModifiedResponse>(`/api/Recorder/AddMarkerToActiveRecording`, request);
    }

    public addParticipant(request: AddOrRemoveParticipantRequest) {
        return super.post<void>(`/api/Recorder/AddParticipant`, request);
    }

    public addPhoneMarker(request: AddPhoneMarkerToActiveRecording) {
        return super.post<void>(`/api/Recorder/AddPhoneMarker`, request);
    }

    public addPhoneMarkerToActiveRecording(callee: string, audioSocketId: string, action: string) {
        return super.get<void>(`/api/Recorder/AddPhoneMarkerToActiveRecording`, {callee: callee, audioSocketId: audioSocketId, action: action});
    }

    public addSelectedPlayer(request: AddSelectedPlayerRequest) {
        return super.post<boolean>(`/api/Recorder/AddSelectedPlayer`, request);
    }
/**
 * Starts broadcasting the given scenario recording to the given players in the given training room with the given camera layout preset.
 */ 

    public broadcastTo(request: BroadcastToRequest) {
        return super.post<string[]>(`/api/Recorder/BroadcastTo`, request);
    }

    public canStopRecording(scenarioRecordingId: string) {
        return super.get<CanStopRecordingErrorCode>(`/api/Recorder/CanStopRecording`, {scenarioRecordingId: scenarioRecordingId});
    }

    public changeCameraLayoutPreset(request: ChangeCameraLayoutPresetRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/ChangeCameraLayoutPreset`, request);
    }

    public changeRoom(request: ChangeRoomRequest) {
        return super.post<ChangeRoomResponse>(`/api/Recorder/ChangeRoom`, request);
    }

    public changeTrainingSessionState(request: ChangeTrainingSessionStateRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/ChangeTrainingSessionState`, request);
    }

    public continueTrainingSession(request: ContinueTrainingSessionRequest) {
        return super.post<ContinueTrainingSessionResponse>(`/api/Recorder/ContinueTrainingSession`, request);
    }

    public createProTrainingSession(request: CreateProTrainingSessionRequest) {
        return super.post<TeamTrainingSession>(`/api/Recorder/CreateProTrainingSession`, request);
    }

    public deselectVogMedia(request: SelectAudioMediaRequest) {
        return super.post<boolean>(`/api/Recorder/DeselectVogMedia`, request);
    }

    public deselectVopMedia(request: SelectAudioMediaRequest) {
        return super.post<boolean>(`/api/Recorder/DeselectVopMedia`, request);
    }

    public getActiveTrainingSessionsForRecorder() {
        return super.get<ActiveTrainingSessionResponse>(`/api/Recorder/GetActiveTrainingSessionsForRecorder`, );
    }

    public getCurrentScenarioRecordingsByTrainingSessionId(trainingSessionId: string) {
        return super.get<ScenarioRecording[]>(`/api/Recorder/GetCurrentScenarioRecordingsByTrainingSessionId`, {trainingSessionId: trainingSessionId});
    }

    public getMarkersetByScenarioRecordingId(scenarioRecordingId: string) {
        return super.get<Markerset>(`/api/Recorder/GetMarkersetByScenarioRecordingId`, {scenarioRecordingId: scenarioRecordingId});
    }

    public getParticipants(scenarioRecordingId: string, participantType: ParticipantType) {
        return super.get<SimUser[]>(`/api/Recorder/GetParticipants`, {scenarioRecordingId: scenarioRecordingId, participantType: participantType});
    }

    public getRecorderMappingById(recorderId: string) {
        return super.get<RecorderMapping>(`/api/Recorder/GetRecorderMappingById`, {recorderId: recorderId});
    }

    public getRunningScenarioRecordings(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<ScenarioRecording>>(`/api/Recorder/GetRunningScenarioRecordings`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getScenarioRecordingById(scenarioRecordingId: string) {
        return super.get<ScenarioRecording>(`/api/Recorder/GetScenarioRecordingById`, {scenarioRecordingId: scenarioRecordingId});
    }
/**
 * SimService dependency removed
 */ 

    public getTrainingRoomById(trainingRoomId: string) {
        return super.get<TrainingRoom>(`/api/Recorder/GetTrainingRoomById`, {trainingRoomId: trainingRoomId});
    }

    public getTrainingRoomsByTrainingSessionId(trainingSessionId: string) {
        return super.get<TrainingRoom[]>(`/api/Recorder/GetTrainingRoomsByTrainingSessionId`, {trainingSessionId: trainingSessionId});
    }

    public getTrainingRoomsByWebRecorder() {
        return super.get<TrainingRoom[]>(`/api/Recorder/GetTrainingRoomsByWebRecorder`, );
    }

    public getVOGSetById(vogSetId: string) {
        return super.get<VOGSet>(`/api/Recorder/GetVOGSetById`, {vogSetId: vogSetId});
    }

    public getVtpSetById(vopSetId: string) {
        return super.get<VTPSet>(`/api/Recorder/GetVtpSetById`, {vopSetId: vopSetId});
    }

    public playMediaOnMediaScreen(request: PlayMediaOnMediaScreenRequest) {
        return super.post<boolean>(`/api/Recorder/PlayMediaOnMediaScreen`, request);
    }

    public playMediaVog(request: PlayAudioMediaRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/PlayMediaVog`, request);
    }

    public playMediaVop(request: PlayAudioMediaRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/PlayMediaVop`, request);
    }

    public prepareScheduledTrainingSessionForRecording(request: ReleaseTrainingSessionStateRequest) {
        return super.post<PrepareScheduledTrainingSessionForRecordingResponse>(`/api/Recorder/PrepareScheduledTrainingSessionForRecording`, request);
    }

    public removeParticipant(request: AddOrRemoveParticipantRequest) {
        return super.post<void>(`/api/Recorder/RemoveParticipant`, request);
    }

    public removeSelectedPlayer(request: RemoveSelectedPlayerRequest) {
        return super.post<boolean>(`/api/Recorder/RemoveSelectedPlayer`, request);
    }

    public selectVogMedia(request: SelectAudioMediaRequest) {
        return super.post<boolean>(`/api/Recorder/SelectVogMedia`, request);
    }

    public selectVopMedia(request: SelectAudioMediaRequest) {
        return super.post<boolean>(`/api/Recorder/SelectVopMedia`, request);
    }

    public setGroupVolumeChannel(request: SetGroupVolumeChannelRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/SetGroupVolumeChannel`, request);
    }
/**
 * This method can be called if you want to change the volume of the vog, vop and vtt channels.
 */ 

    public setRecorderVolumeChannel(request: SetRecorderVolumeChannelRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/SetRecorderVolumeChannel`, request);
    }

    public setScenarioRecordingMessage(request: SetScenarioRecordingMessageRequest) {
        return super.post<boolean>(`/api/Recorder/SetScenarioRecordingMessage`, request);
    }

    public setVogMediaLooping(request: SetAudioMediaLoopingRequest) {
        return super.post<boolean>(`/api/Recorder/SetVogMediaLooping`, request);
    }

    public setVolumeChannel(request: SetVolumeChannelRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/SetVolumeChannel`, request);
    }

    public setVopMediaLooping(request: SetAudioMediaLoopingRequest) {
        return super.post<boolean>(`/api/Recorder/SetVopMediaLooping`, request);
    }

    public setWebRecorderShowAbsoluteTime(request: UpdateShowAbsoluteTimeRequest) {
        return super.post<boolean>(`/api/Recorder/SetWebRecorderShowAbsoluteTime`, request);
    }

    public startRecording(request: StartGroupRecordingRequest) {
        return super.post<StartGroupRecordingReponse>(`/api/Recorder/StartRecording`, request);
    }
/**
 * Stops broadcasting to the given players.
 */ 

    public stopBroadcastingTo(request: StopBroadcastingToRequest) {
        return super.post<void>(`/api/Recorder/StopBroadcastingTo`, request);
    }

    public stopMediaOnMediaScreen(request: StopMediaOnMediaScreenRequest) {
        return super.post<boolean>(`/api/Recorder/StopMediaOnMediaScreen`, request);
    }

    public stopMediaVog(request: StopAudioMediaRequest) {
        return super.post<boolean>(`/api/Recorder/StopMediaVog`, request);
    }

    public stopMediaVop(request: StopAudioMediaRequest) {
        return super.post<boolean>(`/api/Recorder/StopMediaVop`, request);
    }

    public stopRecording(request: StopMultiRecordingRequest) {
        return super.post<StopRecordingResponse>(`/api/Recorder/StopRecording`, request);
    }

    public toggleCameraViewMode(request: UpdateCameraViewModeRequest) {
        return super.post<boolean>(`/api/Recorder/ToggleCameraViewMode`, request);
    }

    public toggleChannel(request: ToggleMuteChannelRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/ToggleChannel`, request);
    }

    public toggleGroupChannel(request: ToggleGroupMuteChannelRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/ToggleGroupChannel`, request);
    }

    public toggleGroupSoloChannel(request: ToggleGroupSoloChannelRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/ToggleGroupSoloChannel`, request);
    }

    public toggleSoloChannel(request: ToggleSoloChannelRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/ToggleSoloChannel`, request);
    }

    public toggleVogVopVttOutputChannel(request: ToggleVogVopVttOutputChannelRequest) {
        return super.post<boolean>(`/api/Recorder/ToggleVogVopVttOutputChannel`, request);
    }
/**
 * Toggles the vignette showing state of the web recorder. If ForceState is provided, it will set the state to that value.
 */ 

    public toggleWebRecorderIsVignetteShowing(request: ToggleWebRecorderIsVignetteShowingRequest) {
        return super.post<void>(`/api/Recorder/ToggleWebRecorderIsVignetteShowing`, request);
    }

    public updateMarkerTextToActiveRecording(request: UpdateMarkerTextRequest) {
        return super.post<SuccessResponse>(`/api/Recorder/UpdateMarkerTextToActiveRecording`, request);
    }
/**
 * Updates the metadata of a recording. Only non-null request parameters will be updated.
 */ 

    public updateRecordingMetaData(request: UpdateRecordingMetaDataRequest) {
        return super.post<ScenarioRecording>(`/api/Recorder/UpdateRecordingMetaData`, request);
    }

    public updateVolumeOfCurrentMedia(updateVolumeOfCurrentMediaRequest: UpdateVolumeOfCurrentMediaRequest) {
        return super.post<boolean>(`/api/Recorder/UpdateVolumeOfCurrentMedia`, updateVolumeOfCurrentMediaRequest);
    }
}